import { createAction, props } from '@ngrx/store';
import { UserSettings } from 'src/app/shared/models/user-settings.model';

export const setUser = createAction(
  '[User] Set User',
  props<{ user: string }>()
);

export const setUserSubstitutees = createAction(
  '[User] Set User Substitutees',
  props<{ substitutees: string[] }>()
);
export const setUserTheme = createAction(
  '[User] Set User Theme',
  props<{ theme: string }>()
);
export const setUserSettings = createAction(
  '[User] Set User Settings',
  props<{ settings: UserSettings }>()
);

export const resetUser = createAction(
  '[User] Reset User',
  props<{ user: string }>()
);
